/**
 * Mill-Box AI チャットのエラーコード体系。
 *
 * Anthropic API 側のエラー（クレジット残高不足・APIキー無効等）は、原因の詳細を
 * サーバーログにのみ残し、クライアントにはこのコードだけを見せる（詳細を伏せる方針）。
 * サーバー側のマッピング（SDK のエラー文字列 → このコード）は SDK の型に依存するため
 * shared には置かず、`packages/backend/ai-agent` 側に置く（このファイルは表示用の型と文言のみ）。
 *
 * コード表（AI-0001〜AI-0010 は SDKAssistantMessageError、AI-0011〜AI-0014 は
 * result メッセージの異常 subtype に対応。AI-0099 は未知の値のフォールバック）:
 * - AI-0001: authentication_failed（APIキー無効）
 * - AI-0002: billing_error（クレジット残高不足）
 * - AI-0003: rate_limit
 * - AI-0004: overloaded
 * - AI-0005: oauth_org_not_allowed
 * - AI-0006: account_on_hold
 * - AI-0007: invalid_request
 * - AI-0008: model_not_found
 * - AI-0009: server_error
 * - AI-0010: max_output_tokens
 * - AI-0011: result subtype 'error_max_turns'
 * - AI-0012: result subtype 'error_during_execution'
 * - AI-0013: result subtype 'error_max_budget_usd'
 * - AI-0014: result subtype 'error_max_structured_output_retries'
 * - AI-0099: unknown（上記以外すべてのフォールバック）
 */
export type AiAgentErrorCode =
  | 'AI-0001'
  | 'AI-0002'
  | 'AI-0003'
  | 'AI-0004'
  | 'AI-0005'
  | 'AI-0006'
  | 'AI-0007'
  | 'AI-0008'
  | 'AI-0009'
  | 'AI-0010'
  | 'AI-0011'
  | 'AI-0012'
  | 'AI-0013'
  | 'AI-0014'
  | 'AI-0099'

// エラーの内実（残高不足・認証失敗等）はここに一切含めない。サーバーログには別途、
// 生の理由（SDK のエラー文字列・result.errors 等）を requestId 付きで記録する
// （packages/backend/ai-agent 側。docs/develop/millbox_ai_chat_agent.md 参照）
export function aiAgentErrorMessage(code: AiAgentErrorCode): string {
  return `AIの応答中にエラーが発生しました（エラーコード: ${code}）。時間をおいて再度お試しください。解消しない場合は管理者にお問い合わせください。`
}
